/**
 * Wrap Contacta form submit button text in spans for hover animation
 */
export default function initContactaButton() {
  // Function to wrap button text
  function wrapButtonText(button) {
    // Skip if already wrapped
    if (button.querySelector('span > span')) {
      return;
    }

    const text = button.textContent.trim();
    if (!text) return;

    // Create the wrapper structure
    const wrapper = document.createElement('span');
    wrapper.className = 'relative overflow-hidden';
    
    const span1 = document.createElement('span');
    span1.className = 'transition-all inline-block';
    span1.textContent = text;
    
    const span2 = document.createElement('span');
    span2.className = 'transition-all absolute top-full inset-x-0';
    span2.setAttribute('aria-hidden', 'true');
    span2.textContent = text;
    
    wrapper.appendChild(span1);
    wrapper.appendChild(span2);
    
    // Clear button and add wrapper
    button.textContent = '';
    button.appendChild(wrapper);
  }

  // Watch for Contacta form buttons
  function observeButtons() {
    const observer = new MutationObserver((mutations) => {
      const submitButton = document.querySelector('.contacta-col .submitBtn button[type="submit"]');
      if (submitButton && !submitButton.querySelector('span > span')) {
        wrapButtonText(submitButton);
      }
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check immediately
    const submitButton = document.querySelector('.contacta-col .submitBtn button[type="submit"]');
    if (submitButton) {
      wrapButtonText(submitButton);
    }

    // Check periodically as a fallback (Contacta forms load asynchronously)
    const checkInterval = setInterval(() => {
      const submitButton = document.querySelector('.contacta-col .submitBtn button[type="submit"]');
      if (submitButton && !submitButton.querySelector('span > span')) {
        wrapButtonText(submitButton);
        clearInterval(checkInterval);
      }
    }, 500);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeButtons);
  } else {
    observeButtons();
  }
}
